import React, { Component } from "react";
import Loader from "../../../../Loader";
import __ from "lodash";
import { CONFIG, CONFIG_UTIL } from "../../../../../config";
import accountManagement from "../../../../../apis/accountManagement";
import utilManagement from "../../../../../apis/utilManagement";
import { Link } from "react-router-dom";
import { Row, Col, Alert, Modal } from "react-bootstrap";
import env from "react-dotenv";

class ListSiswaCbt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearch: false,
            openModal: false,
            renderSiswas: false,
            siswas: [],
            listMapel: [],
            listMapelSbmptn: [],
            idKpLemparan: null,
            idJadwalLemparan: null,
            urlAkm: "http://18.140.135.175:3000/rptakmsiswa/",
        };
    }

    async componentDidMount() {
        this.getSiswas();
    }

    componentDidUpdate(prevProps) {
        if (this.props.idKelasParalel != prevProps.idKelasParalel || this.props.idJadwalCbt != prevProps.idJadwalCbt) {
            this.getSiswas();
        }
    }

    async getSiswas() {
        if (this.props.idJadwalCbt != null && this.props.idKelasParalel !== null) {
            this.setState({ isSearch: true, siswas: [] });
            // dinamis url by path url
            let url = null;
            {
                if (this.props.kodeAspek === "TA") url = CONFIG.REPORT_CBT_STA_LIST_SISWA;
                else url = CONFIG.REPORT_CBT_LIST_SISWA;
            }
            const response = await accountManagement
                .get(url, {
                    params: {
                        tahunAjaran: this.props.tahunAjaran,
                        idJadwalCbt: this.props.idJadwalCbt,
                        idKelasParalel: this.props.kodeSubTipe === "SBMPTN" ? null : this.props.idKelasParalel,
                        idKelas: this.props.idKelas,
                        idSekolah: this.props.idSekolah
                    },
                })
                .catch(function (error) {});
            if (response) {
                if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    var siswane = response.data.data;
                    var mapele = [];
                    if(this.props.kodeSubTipe === "SBMPTN" || this.props.kodeSubTipe === "TRYOUT") {
                        var bar = new Promise((resolve, reject) => {
                            siswane.map(async(value, index, array) => {
                                // console.log(value);
                                this.setState({ listMapel: [] });
                                const res = await accountManagement.post(CONFIG.FETCH_DETAIL_CBT_SISWA_BY_ID_JADWAL, {
                                        idSiswa: value.idSiswa,
                                        idHeaderHasilCbt: value.idHeaderHasilCbt,
                                        idJadwalCbt: this.props.idJadwalCbt,
                                        tipe: this.props.kodeSubTipe
                                    })
                                    .catch(function (error) {});

                                if (res) {
                                    if (res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                                        mapele = res.data.data.mapelCbt;
                                        value.listMapel = mapele;
                                    }
                                }
                                
                                if (index === array.length -1) resolve();
                            });
                        });

                        bar.then(() => {
                            this.setState({ 
                                siswas: siswane,
                                listMapelSbmptn: mapele                                
                            });

                            setTimeout(() => {
                                this.setState({ 
                                    isSearch: false,
                                    renderSiswas:true
                                })
                            }, 3000);
                        });
                    } 
                    else {
                        this.setState({
                            siswas: response.data.data,
                            isSearch: false,
                            renderSiswas: true,
                        });
                    }
                } else {
                    alert(response.data.errorSchema.errorMessage)
                    this.setState({isSearch: false})
                }
                
            }
        }
    }

    renderSiswa() {
        if (this.props.tipeCbt === "AGCU" || this.props.tipeCbt === "STA") {
            return (
                <table className="table table-stripped">
                    <thead>
                        <th width="5%">No.</th>
                        <th>Nama Siswa</th>
                        {this.props.kodeAspek !== "TA" && (
                            <th className="text-center" width="20%">
                                Agcu Akademik
                            </th>
                        )}
                        {this.props.kodeAspek !== "TA" && (
                            <th className="text-center" width="20%">
                                Agcu Non Akademik
                            </th>
                        )}
                        <th className="text-center" width="20%">
                            Report Siswa
                        </th>
                    </thead>
                    <tbody>
                        {this.state.isSearch && (
                            <tr key="9000">
                                <td colSpan={3}>
                                    <Loader />
                                </td>{" "}
                            </tr>
                        )}
                        {this.state.siswas.map((data, i) => (
                            <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{data.namaSiswa}</td>
                                {this.props.kodeAspek !== "TA" && (
                                    <td className="text-center">
                                        <button className="btn btn-outline-info" title="Detail Pengerjaan TEST Akademik" onClick={() => this.handleModal(data.idSiswa, data.idHeaderHasilCbt, "akademik")}>
                                            <li className="fa fa-info"></li>
                                        </button>
                                        {/* {data.statusPengerjaan === data.jumlahSubTest ? 
                                <i className="fa fa-check text-success" aria-hidden="true"></i> : <i className="fa fa-remove text-danger" aria-hidden="true"></i>} */}
                                    </td>
                                )}
                                {this.props.kodeAspek !== "TA" && (
                                    <td className="text-center">
                                        <button className="btn btn-outline-success" title="Detail Pengerjaan TEST NON Akademik" onClick={() => this.handleModal(data.idSiswa, data.idHeaderHasilCbt, "non")}>
                                            <li className="fa fa-info"></li>
                                        </button>
                                        {/* {data.statusAgcu === data.jumlahSubAgcu ? 
                                <i className="fa fa-check text-success" aria-hidden="true"></i> : <i className="fa fa-remove text-danger" aria-hidden="true"></i>} */}
                                    </td>
                                )}
                                {this.props.kodeAspek === "TA" ? (
                                    <td className="text-center">
                                        {data.statusAgcu === "29" ? (
                                            <>
                                                {this.props.namaJadwalCbt.includes("ST - ") ? (
                                                    <a
                                                        className="btn btn-info"
                                                        title="Detail report siswa"
                                                        href={process.env.REACT_APP_URL_SISWA_FE + "/agcu/pdf/hasilAgcuTa_sma.html?" + this.props.idJadwalCbt + "/" + this.props.idProfilCbt + "/" + data.idSiswa}
                                                        target="_blank"
                                                    >
                                                        <li className="fa fa-print"></li>
                                                    </a>
                                                ) : (
                                                    <a
                                                        className="btn btn-info"
                                                        title="Detail report siswa"
                                                        href={process.env.REACT_APP_URL_SISWA_FE + "/agcu/pdf/hasilAgcuTa_smk.html?" + this.props.idJadwalCbt + "/" + this.props.idProfilCbt + "/" + data.idSiswa}
                                                        target="_blank"
                                                    >
                                                        <li className="fa fa-print"></li>
                                                    </a>
                                                )}
                                            </>
                                        ) : (
                                            // <>
                                            //{this.props.account.namaUser.includes('SMA') ?
                                            //     <a className="btn btn-info" title="Detail report siswa"
                                            //       href={'http://k8s-default-eduprime-73588515d6-253349699.ap-southeast-1.elb.amazonaws.com/agcu/pdfHasilAgcuTa_sma.html?'+
                                            //             this.props.idJadwalCbt+'/'+this.props.idProfilCbt+'/'+data.idSiswa} target="_blank">
                                            //</>     <li className="fa fa-print"></li>
                                            // </a> :
                                            //<a className="btn btn-info" title="Detail report siswa"
                                            //    href={'http://k8s-default-eduprime-73588515d6-253349699.ap-southeast-1.elb.amazonaws.com/agcu/pdfHasilAgcuTa.html?'+
                                            //            this.props.idJadwalCbt+'/'+this.props.idProfilCbt+'/'+data.idSiswa} target="_blank">
                                            //</tr>    <li className="fa fa-print"></li>
                                            //</a>
                                            //</table>}
                                            //</>
                                            <button className="btn btn-danger" title="Belum Mengerjakan sama sekali" aria-hidden="true">
                                                <li className="fa fa-eye-slash"></li>
                                            </button>
                                        )}
                                    </td>
                                ) : (
                                    <td className="text-center">
                                        {data.statusPengerjaan === data.jumlahSubTest && data.statusAgcu === data.jumlahSubAgcu ? (
                                            <a
                                                className="btn btn-info"
                                                title="Detail report siswa"
                                                href={
                                                    env.REACT_APP_URL_SISWA_FE +
                                                    "/agcu/pdfHasilAgcuPsepNew.html?" +
                                                    this.props.account.idSekolah +
                                                    "/" +
                                                    this.props.idKelas +
                                                    "/" +
                                                    this.props.idKelasParalel +
                                                    "/" +
                                                    data.idSiswa +
                                                    "/" +
                                                    this.props.idJadwalCbt +
                                                    "/" +
                                                    this.props.idProfilCbt
                                                }
                                                target="_blank"
                                            >
                                                <li className="fa fa-print"></li>
                                            </a>
                                        ) : (
                                            <button className="btn btn-danger" title="Belum Mengerjakan sama sekali" aria-hidden="true">
                                                <li className="fa fa-eye-slash"></li>
                                            </button>
                                        )}
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }

        if (this.props.tipeCbt === "ASM") {
            return (
                <table className="table table-stripped">
                    <thead>
                        <th width="5%">No.</th>
                        <th>Nama Siswa</th>
                        <th className="text-center" width="10%">
                            Detail Akademik
                        </th>
                        <th className="text-center" width="10%">
                            Detail Non Akademik
                        </th>
                        <th className="text-center" width="10%">
                            Status Pengerjaan
                        </th>
                        {/* <th className="text-center" width='10%'>Detail Pengerjaan</th> */}
                        <th className="text-center" width="10%">
                            Report Siswa
                        </th>
                    </thead>

                    <tbody>
                        {this.state.isSearch && (
                            <tr>
                                <td colSpan={3}>
                                    <Loader />
                                </td>{" "}
                            </tr>
                        )}
                        {this.state.siswas.map((data, i) => (
                            <tr>
                                <td>{i + 1}</td>
                                <td>{data.namaSiswa}</td>
                                <td className="text-center">
                                    <button className="btn btn-outline-info" title="Detail Pengerjaan TEST Akademik" onClick={() => this.handleModal(data.idSiswa, data.idHeaderHasilCbt, "akademik")}>
                                        <li className="fa fa-info"></li>
                                    </button>
                                </td>
                                <td className="text-center">
                                    <button className="btn btn-outline-success" title="Detail Pengerjaan TEST NON Akademik" onClick={() => this.handleModal(data.idSiswa, data.idHeaderHasilCbt, "non")}>
                                        <li className="fa fa-info"></li>
                                    </button>
                                </td>
                                <td className="text-center">
                                    {data.statusPengerjaan === data.jumlahSubTest && data.statusAgcu == 11 ? <i className="fa fa-check text-success" aria-hidden="true"></i> : <i className="fa fa-remove text-danger" aria-hidden="true"></i>}
                                </td>

                                {/* <td className="text-center">
                                {data.statusPengerjaan === data.jumlahSubTest ? 
                                <Link to={{ pathname: '/rekapitulasi/detailexamsiswa/'+data.idSiswa+'/'+this.props.idKelasParalel+'/'+this.props.idJadwalCbt }} target="_blank">
                                    <button className="btn btn-success" title="Lihat Detail" aria-hidden="true">
                                        <li className="fa fa-eye"/>
                                    </button> 
                                </Link> 
                                
                                : 
                                <button className="btn btn-danger" title="Belum Mengerjakan sama sekali" aria-hidden="true">
                                    <li className="fa fa-eye-slash">
    
                                    </li>
                                </button>}
                            </td> */}

                                <td className="text-center">
                                    {data.statusPengerjaan === data.jumlahSubTest && data.statusAgcu == 11 ? (
                                        <a
                                            className="btn btn-info"
                                            title="Detail report siswa"
                                            href={"/rptakmsiswa/" + data.idSiswa + "/" + this.props.idJadwalCbt + "/" + this.props.idSekolah + "/" + this.props.idKelas + "/" + this.props.idKelasParalel}
                                            target="_blank"
                                        >
                                            <li className="fa fa-print"></li>
                                        </a>
                                    ) : (
                                        <button className="btn btn-danger" title="Belum Mengerjakan sama sekali" aria-hidden="true">
                                            <li className="fa fa-eye-slash"></li>
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }

        if (this.props.tipeCbt === "ENSA") {
            return (
                <table className="table table-stripped">
                    <thead>
                        <th width="5%">No.</th>
                        <th>Nama Siswa</th>
                        <th className="text-center" width="10%">
                            Detail Akademik
                        </th>
                        <th className="text-center" width="10%">
                            Detail Non Akademik
                        </th>
                        <th className="text-center" width="10%">
                            Status Pengerjaan
                        </th>
                        {/* <th className="text-center" width='10%'>Detail Pengerjaan</th> */}
                        <th className="text-center" width="10%">
                            Report Siswa
                        </th>
                    </thead>

                    <tbody>
                        {this.state.isSearch && (
                            <tr>
                                <td colSpan={3}>
                                    <Loader />
                                </td>{" "}
                            </tr>
                        )}
                        {this.state.siswas.map((data, i) => (
                            <tr>
                                <td>{i + 1}</td>
                                <td>{data.namaSiswa}</td>
                                <td className="text-center">
                                    <button className="btn btn-outline-info" title="Detail Pengerjaan TEST Akademik" onClick={() => this.handleModal(data.idSiswa, data.idHeaderHasilCbt, "akademik")}>
                                        <li className="fa fa-info"></li>
                                    </button>
                                </td>
                                <td className="text-center">
                                    <button className="btn btn-outline-success" title="Detail Pengerjaan TEST NON Akademik" onClick={() => this.handleModal(data.idSiswa, data.idHeaderHasilCbt, "non")}>
                                        <li className="fa fa-info"></li>
                                    </button>
                                </td>
                                <td className="text-center">
                                    {data.statusPengerjaan === data.jumlahSubTest && data.statusAgcu >= 11 ? <i className="fa fa-check text-success" aria-hidden="true"></i> : <i className="fa fa-remove text-danger" aria-hidden="true"></i>}
                                </td>

                                <td className="text-center">
                                    {data.statusPengerjaan === data.jumlahSubTest ? (
                                        <a
                                            className="btn btn-info"
                                            title="Detail report siswa"
                                            href={"/rptensaSiswa/" +
                                                this.props.idJadwalCbt +
                                                "/" +
                                                data.idSiswa +
                                                "/" +
                                                this.props.account.idSekolah +
                                                "/" +
                                                this.props.idKelas +
                                                "/" +
                                                this.props.idKelasParalel +
                                                "/" +
                                                this.props.tahunAjaran
                                            }
                                            target="_blank"
                                        >
                                            <li className="fa fa-print"></li>
                                        </a>
                                    ) : (
                                        <button className="btn btn-danger" title="Belum Mengerjakan sama sekali" aria-hidden="true">
                                            <li className="fa fa-eye-slash"></li>
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }

        if (this.props.kodeSubTipe === "TRYOUT" || this.props.kodeSubTipe === "SBMPTN") {
            return (
                <table className="table table-stripped">
                    <thead>
                        <th width="5%">No.</th>
                        <th width="15%">Nama Siswa</th>
                        {this.state.listMapelSbmptn.map((mapel, i) =>
                        <th key={i} className="text-center" width={70/this.state.listMapelSbmptn.length+"%"}>{mapel.namaMataPelajaran}</th>
                        )}
                        {/* <th className="text-center" width="10%">
                            Detail Pengerjaan
                        </th> */}
                        {this.props.tipeCbt != "EXAM" && (
                            <th className="text-center" width="10%">
                                Report Siswa
                            </th>
                        )}
                    </thead>

                    <tbody>
                        {this.state.isSearch && (
                            <tr>
                                <td colSpan={3}>
                                    <Loader />
                                </td>{" "}
                            </tr>
                        )}
                        {this.state.renderSiswas && <>
                        {this.state.siswas.map((data, i) => (
                            <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{data.namaSiswa}</td>
                                {data.listMapel !== undefined && <>
                                    {data.listMapel.map((mapel,no) => 
                                        <td key={no} className="text-center">
                                            {mapel.statusPengerjaan === "1" ? <i className="fa fa-check text-success" aria-hidden="true"></i> : <i className="fa fa-remove text-danger" aria-hidden="true"></i>}
                                        </td>
                                    )}
                                </>}
                                {/* <td>
                                    <button className="btn btn-outline-info" title="Detail Pengerjaan TEST Akademik" onClick={() => this.handleModal(data.idSiswa, data.idHeaderHasilCbt, "akademik")}>
                                        <li className="fa fa-info"></li>
                                    </button>
                                    {data.statusPengerjaan === data.jumlahSubTest ? 
                                <i className="fa fa-check text-success" aria-hidden="true"></i> : <i className="fa fa-remove text-danger" aria-hidden="true"></i>}
                                </td> */}

                                {/* <td className="text-center">
                                    {data.statusPengerjaan === data.jumlahSubTest ? (
                                        <Link
                                            to={{
                                                pathname: "/rekapitulasi/detailexamsiswa/" + data.idSiswa + "/" + this.props.idKelasParalel + "/" + this.props.idJadwalCbt,
                                            }}
                                            target="_blank"
                                        >
                                            <button className="btn btn-success" title="Lihat Detail" aria-hidden="true">
                                                <li className="fa fa-eye" />
                                            </button>
                                        </Link>
                                    ) : (
                                        <button className="btn btn-danger" title="Belum Mengerjakan sama sekali" aria-hidden="true">
                                            <li className="fa fa-eye-slash"></li>
                                        </button>
                                    )}
                                </td> */}
                                {this.props.tipeCbt != "EXAM" && (
                                    <td className="text-center">
                                        {data.statusPengerjaan === data.jumlahSubTest ? (
                                            <>
                                            <a className="btn btn-info mr-2" title="Detail report siswa"                                            
                                                href={process.env.REACT_APP_URL_SISWA_FE + '/report/tkaSiswa.html?'+  this.props.account.idSekolah+'/'+this.props.idKelas+'/'+
                                                                                                                this.props.idKelasParalel+'/'+data.idSiswa+'/'+
                                                                                                                this.props.idJadwalCbt+'/'+this.props.idProfilCbt} target="_blank">
                                                <li className="fa fa-print"></li>
                                            </a>
                                            <a className="btn btn-success" title="Data sertifikasi"                                            
                                                href={process.env.REACT_APP_URL_SISWA_FE + '/report/tkaSertifikat.html?'+  this.props.account.idSekolah+'/'+this.props.idKelas+'/'+
                                                                                                                this.props.idKelasParalel+'/'+data.idSiswa+'/'+
                                                                                                                this.props.idJadwalCbt+'/'+this.props.idProfilCbt} target="_blank">
                                                <li className="fa fa-certificate"></li>
                                            </a>
                                            </>

                                            // <a
                                            //     className="btn btn-info"
                                            //     title="Detail report siswa"
                                            //     href={"http://45.64.97.198:8061/rekapitulasi/reporttoosiswa/" + this.props.idJadwalCbt + "/" + this.props.idProfilCbt + "/" + this.props.idKelasParalel + "/" + data.idSiswa}
                                            //     target="_blank"
                                            // >
                                            //     <li className="fa fa-print"></li>
                                            // </a>
                                        ) : (
                                            <button className="btn btn-danger" title="Belum Mengerjakan sama sekali" aria-hidden="true">
                                                <li className="fa fa-eye-slash"></li>
                                            </button>
                                        )}
                                    </td>
                                )}
                            </tr>
                        ))}
                        </>}
                    </tbody>
                </table>
            );
        }
    }

    async handleModal(idSiswa, idHeader, tipe) {
        this.setState({
            openModal: true,
            idSiswa: idSiswa,
            idHeaderHasilCbt: idHeader,
            tipe: tipe,
        });

        this.setState({ isSearch: true, listMapel: [] });
        const response = await accountManagement
            .post(CONFIG.FETCH_DETAIL_CBT_SISWA_BY_ID_JADWAL, {
                idSiswa: idSiswa,
                idHeaderHasilCbt: idHeader,
                idJadwalCbt: this.props.idJadwalCbt,
                tipe: tipe,
            })
            .catch(function (error) {});

        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    listMapel: response.data.data.mapelCbt,
                });
            }
            this.setState({ isSearch: false });
        }
    }

    renderModalDetail() {
        return (
            <Modal show={this.state.openModal} onHide={() => this.setState({ openModal: false })} aria-labelledby="example-custom-modal-styling-title" size="lg" backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Detail {this.state.tipe == "non" ? "Non Akademik" : "Akademik"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.isSearch && <Loader />}
                    {!__.isEmpty(this.state.listMapel) && (
                        <table width="100%">
                            <thead>
                                <tr>
                                    <th width="5%">No</th>
                                    <th>Nama Test</th>
                                    {/* {this.state.tipe !='non' && <th className="text-center">Masuk Test</th> }
                                    {this.state.tipe !='non' && <th className="text-center">Submit Test</th> } */}
                                    <th className="text-center">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.listMapel.map((val, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{val.namaMataPelajaran}</td>
                                        {/* {this.state.tipe !='non' && <td className="text-center">{val.startExamDate != null ? val.startExamDate : '-'}</td> }
                                            {this.state.tipe !='non' && <td className="text-center">{val.submitDate != null ? val.submitDate : '-'}</td> } */}
                                        <td className="text-center">
                                            {/* {val.statusPengerjaan > 0 ? (
                                                <button
                                                    className="btn btn-outline-success"
                                                    title="Sudah Mengumpulkan"
                                                >
                                                    <li className="fa fa-check-square"></li>
                                                </button>
                                            ) : (
                                                <button
                                                    className="btn btn-outline-danger"
                                                    title="Belum Mengumpulkan"
                                                >
                                                    <li className="fa fa-window-close"></li>
                                                </button>
                                            )} */}
                                            {val.namaMataPelajaran == "SK" ? (
                                                val.statusPengerjaan == 6 ? (
                                                    <button className="btn btn-outline-success" title="Sudah Mengumpulkan">
                                                        <li className="fa fa-check-square"></li>
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-outline-danger" title="Belum Mengumpulkan">
                                                        <li className="fa fa-window-close"></li>
                                                    </button>
                                                )
                                            ) : val.namaMataPelajaran == "SLB" ? (
                                                val.statusPengerjaan >= 5 ? (
                                                    <button className="btn btn-outline-success" title="Sudah Mengumpulkan">
                                                        <li className="fa fa-check-square"></li>
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-outline-danger" title="Belum Mengumpulkan">
                                                        <li className="fa fa-window-close"></li>
                                                    </button>
                                                )
                                            ) : val.namaMataPelajaran == "SLB" ? (
                                                val.statusPengerjaan == 5 ? (
                                                    <button className="btn btn-outline-success" title="Sudah Mengumpulkan">
                                                        <li className="fa fa-check-square"></li>
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-outline-danger" title="Belum Mengumpulkan">
                                                        <li className="fa fa-window-close"></li>
                                                    </button>
                                                )
                                            ) : val.statusPengerjaan > 0 ? (
                                                <button className="btn btn-outline-success" title="Sudah Mengumpulkan">
                                                    <li className="fa fa-check-square"></li>
                                                </button>
                                            ) : (
                                                <button className="btn btn-outline-danger" title="Belum Mengumpulkan">
                                                    <li className="fa fa-window-close"></li>
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        return (
            <div style={{ marginTop: "30px" }}>
                {this.renderModalDetail()}
                {this.renderSiswa()}
            </div>
        );
    }
}

export default ListSiswaCbt;
